export const encodeId = (id: string): string => {
  // Simple base64 URL-safe encoding
  return Buffer.from(id, 'utf8')
    .toString('base64')
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

export const decodeId = (token: string): string | null => {
  try {
    let base64 = token.replace(/-/g, '+').replace(/_/g, '/');
    // Restore required padding
    const padding = base64.length % 4;
    if (padding === 2) base64 += '==';
    else if (padding === 3) base64 += '=';
    else if (padding !== 0) return null;

    return Buffer.from(base64, 'base64').toString('utf8');
  } catch {
    return null;
  }
};

export const generateDiamondSlug = (diamond: {
  diamondId: string;
  shape?: string;
  carats?: number;
  col?: string;
  clar?: string;
  cut?: string;
  lab?: string;
  labgrownType?: string;
}): string => {
  const parts: string[] = [];

  if (diamond.carats) {
    parts.push(`${diamond.carats.toFixed(2).replace(/\./g, '-')}-carat`);
  }

  if (diamond.col) {
    parts.push(`${diamond.col.toLowerCase()}-color`);
  }

  if (diamond.clar) {
    parts.push(`${diamond.clar.toLowerCase()}-clarity`);
  }

  if (diamond.cut && diamond.cut !== '-') {
    parts.push(`${diamond.cut.toLowerCase()}-cut`);
  }

  if (diamond.shape) {
    parts.push(diamond.shape.toLowerCase().replace(/\s+/g, '-'));
  }

  if (diamond.lab) {
    parts.push(`${diamond.lab.toLowerCase()}-lab`);
  } else if (diamond.labgrownType) {
    parts.push('lab');
  }

  // Always append encoded id as the last segment
  const encoded = encodeId(diamond.diamondId.replace('DIAMOND/', ''));
  parts.push(encoded);
  return parts.join('-');
};

export const parseDiamondIdFromSlug = (slug: string): string | null => {
  if (!slug) return null;
  // The encoded token is always the last dash-separated segment of the slug.
  const segments = slug.split('-');
  if (segments.length === 0) return null;
  const token = segments[segments.length - 1];
  return decodeId(token);
};

export const generateSettingSlug = (setting: {
  id: string;
  name: string;
  style?: string;
}): string => {
  const parts: string[] = [];
  if (setting.name) {
    parts.push(
      setting.name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, ''),
    );
  }
  if (setting.style) {
    parts.push(setting.style.toLowerCase());
  }
  const numericId = setting.id.split('/').pop() || setting.id;
  const encoded = encodeId(numericId);
  parts.push(encoded);
  return parts.join('-');
};

export const parseSettingIdFromSlug = (slug: string): string | null => {
  if (!slug) return null;
  const segments = slug.split('-');
  if (segments.length === 0) return null;
  const token = segments[segments.length - 1];
  return decodeId(token);
};
